import { Box, Text } from "@prismicio/editor-ui"
import { Editor, EditorContent } from "@tiptap/react"

interface Props {
  editor: Editor | null
}

export function SmartEditor(props: Props) {
  const { editor } = props
  if (editor?.isDestroyed) return null
  return (
    <Box
      overflow="hidden"
      padding={{ block: 12 }}
      flexDirection="column"
      gap={16}
    >
      <Text variant="h3" color="grey12">
        Paste your text here
      </Text>
      <Box
        overflowY="auto"
        flexGrow={1}
        padding={12}
        borderRadius={6}
        border
        borderStyle="solid"
        flexDirection="column"
      >
        <EditorContent style={{ flexGrow: 1 }} editor={editor} />
      </Box>
    </Box>
  )
}
